import React from 'react'

import * as S from './Preview.styled'

type PreviewProps = {
  title: string
  description: string
  artworkUrl: string
}

export const Preview = ({ title, description, artworkUrl }: PreviewProps) => (
  <S.Container>
    <S.Artwork src={artworkUrl} />
    <S.Right>
      <S.Title>{title}</S.Title>
      <S.Description>{description}</S.Description>
    </S.Right>
  </S.Container>
)
